import { useRootStore } from '@hooks/useRootStore';
import { Box, Paper, Typography } from '@mui/material';
import { observer } from 'mobx-react-lite';
import React from 'react';
import OrderCart from '../common/OrderCart';

interface OrderCartBoxProps {
}

const OrderCartBox: React.FC<OrderCartBoxProps> = observer(({ }) => {
    const { orderEditViewStore, userAddressEditViewStore } = useRootStore();
    return (
        <Box position={"sticky"} top={72} height={"100%"}>
            <Paper
                sx={{
                    boxShadow: "0 3px 10px rgba(0,0,0,.1)",
                    width: 312,
                    height: 680,
                    ml: 2,
                    pt: 1,
                    display: "flex",
                    flexDirection: "column"
                }}>
                <Typography textAlign={"center"} variant='h6' fontWeight={600}>Tvoja narudžba</Typography>
                <OrderCart orderEditViewStore={orderEditViewStore} userAddressEditViewStore={userAddressEditViewStore} />
            </Paper>
        </Box>
    )
})

export default OrderCartBox;